import React from 'react';
import { Box, makeStyles, Theme } from '@material-ui/core';
import CircleLoading from './CircleLoading';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <Box
      className={classes.root}
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      flexGrow={1}
    >
      <CircleLoading />
    </Box>
  );
};
